import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Details from './Details';
import ReportDetails from './ReportDetails';
import DashboardDayPicker from './DashboardDayPicker';

import { m } from '../../utils';
import UberConnectModal from '../User/UberConnectModal';
import './index.css';

class Dashboard extends Component {
  componentDidMount() {
    this.props.loadData();
    // this.props.loadUser();
  }

  dashboard = () => {
    const {
      bookingDetail,
      bookings,
      cars = [],
      changeBookingDetail,
      openDialog,
      loadLockbox,
      clearLockbox,
      email,
      account_name,
      uber_password,
      uber_token,
      code
    } = this.props;

    const car = bookingDetail.length
      ? cars.find(c => c.id === bookingDetail[0].car.id)
      : {};
    const isIn30Mins = bookingDetail.length
      ? m(bookingDetail[0].startTime).isBefore(m().add(30, 'minutes'))
      : false;
    const uberURL = `${
      process.env.REACT_APP_API_URL
    }/users/auth/uber?email=${encodeURIComponent(email)}`;

    return window.innerWidth < 768 ? (
      <Redirect to="/downloadapp" />
    ) : (
      <div className="container" style={{ backgroundColor: 'white' }}>
        <div className="general-faq-header">
          <h1>My Dashboard</h1>
        </div>
        <div className="dashboard">
          <div className="dashboard_calendar">
            <DashboardDayPicker
              bookings={bookings}
              changeBookingDetail={changeBookingDetail}
            />
          </div>
          <div className="dashboard_details">
            <Details
              bookings={bookingDetail}
              car={car}
              isIn30Mins={isIn30Mins}
              isUpcomingShift={bookingDetail.isUpcomingShift}
              openDialog={openDialog}
              loadLockbox={loadLockbox}
              clearLockbox={clearLockbox}
              code={code}
            />
          </div>
          <div className="dashboard_report">
            <ReportDetails car={car} isIn30Mins={isIn30Mins} />
          </div>
        </div>

        {!uber_token ? (
          <UberConnectModal
            uberURL={uberURL}
            username={account_name}
            password={uber_password}
          />
        ) : null}
      </div>
    );
  };

  render() {
    const { loggedIn, status } = this.props;
    if (loggedIn && (status === 'subscribed' || status === 'lead')) {
      return <Redirect to="/apply" />;
    } else if (
      loggedIn &&
      (status === 'signed_up' ||
        status === 'account_pending' ||
        status === 'bgc_pending' ||
        status === 'ptc_pending')
    ) {
      return window.innerWidth < 768 ? (
        <Redirect to="/downloadapp" />
      ) : (
        <Redirect to="/profile" />
      );
    } else if (loggedIn && status === 'operating') {
      return window.innerWidth < 768 ? (
        <Redirect to="/downloadapp" />
      ) : (
        this.dashboard()
      );
    } else if (loggedIn) {
      return window.innerWidth < 768 ? (
        <Redirect to="/downloadapp" />
      ) : (
        <Redirect to="/" />
      );
    }
    return window.innerWidth < 768 ? (
      <Redirect to="/downloadapp" />
    ) : (
      <Redirect to="/login" />
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js